const volumeWrapper = document.querySelector('.recharge-subscription-widget');

if (volumeWrapper !== null) {
  function setPurchaceOptions() {
    const purchaseOptions = document.querySelectorAll('input[name="purchaseOption"]');
    for (const purchaseOption of purchaseOptions) {
      if (purchaseOption.getAttribute('data-listener') !== 'true') {
        purchaseOption.setAttribute('data-listener', 'true');
        const subscription_box = document.querySelector(".subscription-box");
        // const vol_container = document.querySelector(".volume-container");
        if (purchaseOption.checked && subscription_box) {
          if (purchaseOption.value === "onetime") {
            subscription_box.classList.add("hide");
          } else if (purchaseOption.value === "subscription") {
            subscription_box.classList.remove("hide");
          }
        }
        purchaseOption.addEventListener('click', function (event) {
          const target = event.target;
          if (subscription_box && target.value === "onetime") {
            subscription_box.classList.add("hide");
          } else {
            subscription_box.classList.remove("hide");
          }
          /*
                    if (purchaseOption.checked && (vol_container || subscription_box)) {
                      if (purchaseOption.value === "onetime") {
                        subscription_box.classList.add("hide");
                        vol_container.classList.remove("hide");
                      } else if (purchaseOption.value === "subscription") {
                        subscription_box.classList.remove("hide");
                        vol_container.classList.add("hide");
                      }
                    }
                    if (subscription_box && target.value === "onetime") {
                      subscription_box.classList.add("hide");
                    } else {
                      subscription_box.classList.remove("hide");
                    }
                    if (vol_container && target.value === "subscription") {
                      document.querySelectorAll(".volume-box").forEach(element => {
                        element.classList.remove("is-selected");
                      });
                      document.querySelector(".volume-box").classList.add("is-selected");
                      document.getElementById('volume-real-qty').value = 1;
                      vol_container.classList.add("hide");
                    } else {
                      document.querySelector(".volume-container").classList.remove("hide");
                    }
                    */
        });
      }
    };
  }

  const volumeDiscountObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      try {
        if (mutation.addedNodes.length > 0) {
          setPurchaceOptions();
        }
      } catch (error) {
        console.log(error)
      }
    }
  });

  volumeDiscountObserver.observe(volumeWrapper, { childList: true, subtree: true });

  function volSelector(el, qty) {
    document.querySelectorAll(".volume-box").forEach(element => {
      element.classList.remove("is-selected");
    });
    el.classList.add("is-selected");
    document.getElementById("volume-real-qty").value = qty;
  }
}
